module.exports = {
  src: __webpack_public_path__ + "graph-text-dots.png",
  width: 2,
  height: 2,
  bytes: 76,
  type: "png",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "graph-text-dots.png";
};


/*****************
 ** WEBPACK FOOTER
 ** ./frontend/containers/profile/graph-text-dots.png
 ** module id = 1112
 ** module chunks = 0
 **/